"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
function transform(css) {
  var rules = css.split(/\s/m).map(function (x) {
    return x.trim();
  }).filter(Boolean);
  return rules.join(' ');
}
function cls(object) {
  return Object.freeze(Object.entries(object).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      css = _ref2[1];
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    acc[key] = transform(css);
    return acc;
  }, {}));
}
exports.default = cls;